export default __webpack_public_path__ + "static/media/book2.45a8b881.svg";